import {ViewerSettings} from "../redux_constants/viewerSettings.constant";

const InitialState = {
  seen_area_status: false,
}

/**
 * @deprecated: [Priyanshu] use displaySettings.redux_reducers.js instead
 * */
export const viewerSettingReducer = ( state = InitialState , action) => {
	switch (action.type) {
		case ViewerSettings.SHOW_SEEN_AREA_CHANGED:
			return Object.assign({}, state, {
				seen_area_status: !state.seen_area_status
			})
		default :
			return state
	}
}
